// src/components/PageCard.jsx
import React from "react";
import SectionRow from "./SectionRow";

/**
 * PageCard
 * Top-level page wrapper used in the Template Builder.
 *
 * Internally this simply renders a SectionRow with `isPage={true}`,
 * but keeping a separate component makes the hierarchy clearer and
 * allows TemplateBuilder to treat depth=0 items as Pages.
 */
export default function PageCard(props) {
  return (
    <div className="indent-wrapper" style={{ marginBottom: 12 }}>
      <SectionRow {...props} isPage indentLevel={0} />
    </div>
  );
}
